/**
 * Landing page listing highlight rows (Airbnb-style horizontal sections).
 * Rows without categoryMatch/categoryId/listingType load all published listings with the given sort.
 * Filter resolution per row:
 *  - listingType: string | string[] — pins pub_listingType (e.g. 'day-pass').
 *  - categoryMatch / categoryId: resolves a category path from the hosted category tree.
 * listingType and category filters can be combined.
 *
 * Every row here costs one SDK query per server-rendered request, whether or not it resolves —
 * `rowIds` on the section only filters at render time. A row whose categoryMatch finds nothing in
 * the hosted category tree is therefore pure cost, so keep this list in sync with the taxonomy.
 * Anything listed here has to appear in a section's `rowIds` too, or it is pure cost.
 * 'lounge' was dropped because nothing referenced it any more. 'newest', 'coliving' and
 * 'individual' were a product decision, not dead weight: the journey simplification cut the
 * homepage from five carousels to three (see FallbackPage.js), and the rows went with the ids.
 */
const landingPage = {
  listingRows: [
    {
      id: 'tagespass',
      titleTranslationKey: 'SectionLandingListingRows.rowTagespassTitle',
      sort: 'createdAt',
      perPage: 10,
      // Filter by listingType, not category — Tagespass / day-pass is a Sharetribe listingType.
      listingType: 'tagespass',
    },
    {
      // Meeting rooms are the product the Zürich supply outreach sells (Sitzungszimmer), and the
      // one a first-time visitor most often searches for; same matcher as the city pages.
      id: 'meeting',
      titleTranslationKey: 'SectionLandingListingRows.rowMeetingTitle',
      sort: 'createdAt',
      perPage: 10,
      categoryMatch: (id, name) =>
        /meeting|konferenz|sitzung/i.test(id) || /meeting|konferenz|sitzung/i.test(name),
    },
    {
      id: 'fixdesk',
      titleTranslationKey: 'SectionLandingListingRows.rowFixdeskTitle',
      sort: 'createdAt',
      perPage: 10,
      // `fix(ed)?` is load-bearing: the hosted category id is `fixed_desk`, and /fix.?desk/ does
      // not match it — `.?` covers only one of the two characters between "fix" and "desk". The
      // row then resolved no category path, was fetched as empty and silently never rendered.
      // Same expression the desk group in components/CategoryShortcuts/categoryGroups.js uses.
      categoryMatch: (id, name) => /fix(ed)?.?desk/i.test(id) || /fix(ed)?.?desk/i.test(name),
    },
  ],
};

export default landingPage;
